import { 
    GetWeatherWidgetLocByPostalCodeActionType,
    GetWeatherWidgetLocByCityIdActionType,
    GetWidgetCurrentStationObsType,
    GetWeatherWidgetHourlyForecastType,
    GetWeatherWidgetForecastIconType,
    GetWeatherWidgetLocFromUserIpType,
    GET_WEATHER_WIDGET_HOURLY_FORECAST,
    GET_WEATHER_WIDGET_CURRENT_STATION_OBS,
    GET_WEATHER_WIDGET_FORECAST_ICON,
    GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID,
    GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP,
    GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE } from '../actions/weatherWidgetsActions';

import { routeHelper } from '../../components/common/utilities/routeHelper';
import { getUrlFromResponse } from '../utilities/forecastIconUrlUtils';
const routePathBase = `//${window.location.host}`;
const defaultIconCode = 999;
const defaultLocName = '--';

interface WeatherWidgetState {
    iconCode: number;
    forecastIconUrl?: string;
    widgetLocationName?: string;
    widgetLocationLat?: number;
    widgetLocationLon?: number;
    currentTemperature?: number;
    forecastRoute?: string;
    mapsRoute?: string;
    aqiRoute?: string;
    locationLoadError: boolean;
    forecastDataError: boolean;
    iconLoadError: boolean;
}

const initialState: WeatherWidgetState = {
    iconCode: defaultIconCode,
    widgetLocationName: defaultLocName,
    forecastRoute: `${routePathBase}${routeHelper.forecastNow}`,
    mapsRoute: `${routePathBase}${routeHelper.maps}`,
    aqiRoute: `${routePathBase}${routeHelper.airQuality}`,
    locationLoadError: false,
    forecastDataError: false,
    iconLoadError: false
};

type WeatherWidgetStateTypes = 
    | GetWeatherWidgetLocByPostalCodeActionType 
    | GetWidgetCurrentStationObsType 
    | GetWeatherWidgetHourlyForecastType 
    | GetWeatherWidgetForecastIconType
    | GetWeatherWidgetLocByCityIdActionType
    | GetWeatherWidgetLocFromUserIpType;

export function weatherWidget(state = initialState, action: WeatherWidgetStateTypes): WeatherWidgetState
{
    switch (action.type)
    {
        case GET_WEATHER_WIDGET_FORECAST_ICON.pending:
        {   
            return {
                ...state,
                iconLoadError: false
            };
        }

        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE.pending:
        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID.pending:
        {
            return {
                ...state,
                locationLoadError: false
            };
        }
        
        case GET_WEATHER_WIDGET_CURRENT_STATION_OBS.pending:
        {
            return {
                ...state,
                forecastDataError: false
            };
        }

        case GET_WEATHER_WIDGET_HOURLY_FORECAST.pending:
        {
            return {
                ...state,
                currentTemperature: undefined
            };
        }

        case GET_WEATHER_WIDGET_CURRENT_STATION_OBS.fulfilled:
        {
            return {
                ...state,
                iconCode: action.payload?.o?.ic,
                currentTemperature: action.payload?.o?.t,
                widgetLocationName: action.payload?.s?.sn,
                widgetLocationLat: action.payload?.s?.la,
                widgetLocationLon: action?.payload?.s?.lo,
                forecastDataError: false
            };
        }

        case GET_WEATHER_WIDGET_CURRENT_STATION_OBS.rejected:
        {            
            return {
                ...state,
                iconCode: defaultIconCode,
                currentTemperature: undefined,
                widgetLocationName: undefined,
                widgetLocationLat: undefined,
                widgetLocationLon: undefined,
                forecastDataError: true
            };
        }

        case GET_WEATHER_WIDGET_HOURLY_FORECAST.fulfilled:
        {
            return {
                ...state,
                iconCode: action.payload?.ic,
                currentTemperature: action.payload?.t
            };
        }

        case GET_WEATHER_WIDGET_HOURLY_FORECAST.rejected:
        {
            return {
                ...state,
                iconCode: defaultIconCode,
                currentTemperature: undefined
            };
        }

        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE.fulfilled:
        {
            const slugName = action.payload?.SlugName;
            
            return {
                ...state,
                widgetLocationName: action.payload?.DisplayCompositeName,
                widgetLocationLat: action.payload?.Latitude,
                widgetLocationLon: action?.payload?.Longitude,
                forecastRoute: `${routePathBase}${routeHelper.forecastNow}${slugName}`,
                mapsRoute: `${routePathBase}${routeHelper.maps}${slugName}`,
                aqiRoute: `${routePathBase}${routeHelper.airQuality}${slugName}`
            };
        }

        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID.fulfilled:
        {
            const slugName = action.payload?.Result?.SlugName;
            
            return {
                ...state,
                widgetLocationName: action.payload?.Result?.DisplayCompositeName,
                widgetLocationLat: action.payload?.Result?.Latitude,
                widgetLocationLon: action?.payload?.Result?.Longitude,
                forecastRoute: `${routePathBase}${routeHelper.forecastNow}${slugName}`,
                mapsRoute: `${routePathBase}${routeHelper.maps}${slugName}`,
                aqiRoute: `${routePathBase}${routeHelper.airQuality}${slugName}`
            };
        }

        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_POSTAL_CODE.rejected:
        case GET_WEATHER_WIDGET_LOCATION_DETAILS_BY_CITY_ID.rejected:
        {            
            return {
                ...state,
                widgetLocationName: undefined,
                widgetLocationLat: undefined,
                widgetLocationLon: undefined,
                locationLoadError: true,
                forecastRoute: `${routePathBase}${routeHelper.forecastNow}`,
                mapsRoute: `${routePathBase}${routeHelper.maps}`,
                aqiRoute: `${routePathBase}${routeHelper.airQuality}`
            };
        }

        case GET_WEATHER_WIDGET_FORECAST_ICON.fulfilled:
        {
            const iconUrl = getUrlFromResponse(action.payload?.Result);
            
            return {
                ...state,
                forecastIconUrl: iconUrl
            };
        }

        case GET_WEATHER_WIDGET_FORECAST_ICON.rejected:
        {
            return {
                ...state,
                forecastIconUrl: undefined,
                iconLoadError: true
            };
        }

        case GET_WEATHER_WIDGET_LOCATION_DETAILS_FROM_USER_IP: 
        {
            return {
                ...state,
                widgetLocationName: action.payload?.widgetLocationName,
                widgetLocationLat: action.payload?.widgetLocationLat,
                widgetLocationLon: action.payload?.widgetLocationLon
            };
        }
    }

    return state;
}